import { createAction, props } from '@ngrx/store';

import { StepAssigneeTableItem } from '@main-application/management/components/turnover-configuration/components/turnover-configuration-step-assignees/config/interfaces/step-assignee-table-item.interface';
import { PropertyAssignees } from '@main-application/management/components/turnover-configuration/components/turnover-configuration-step-assignees/config/interfaces/step-assignees';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';
import { RestWorkflowStepAssignmentModel } from '@shared/interfaces/rest-workflow-step-assignment-model.interface';

/* Load Responsible Parties */
export const loadResponsibleParties = createAction(
  '[StepAssignees] load responsible parties',
  props<{ portfolioId: number }>()
);
export const loadResponsiblePartiesSuccess = createAction(
  '[StepAssignees] load responsible parties Success',
  props<{ responsibleParties: RestWorkflowStepAssignmentModel[] }>()
);
export const loadResponsiblePartiesFailure = createAction('[StepAssignees] load responsible parties failure');

export const setAllStepAssigneeList = createAction(
  '[StepAssignees] setAllStepAssigneeList',
  props<{ allStepAssigneeList: StepAssigneeTableItem[] }>()
);

/* Create Responsible Parties */
export const createResponsibleParties = createAction(
  '[StepAssignees] create responsible parties',
  props<{ responsibleParties: RestWorkflowStepAssignmentModel[] }>()
);
export const createResponsiblePartiesSuccess = createAction(
  '[StepAssignees] create responsible parties success',
  props<{ createResponsibleParties: RestWorkflowStepAssignmentModel[] }>()
);
export const createResponsiblePartiesFailure = createAction('[StepAssignees] create responsible parties failure');

/* Update Responsible Parties */
export const updateResponsibleParties = createAction(
  '[StepAssignees] update responsible parties',
  props<{ responsibleParties: RestWorkflowStepAssignmentModel[] }>()
);
export const updateResponsiblePartiesSuccess = createAction(
  '[StepAssignees] update responsible parties success',

  props<{ updateResponsibleParties: RestWorkflowStepAssignmentModel[] }>()
);
export const updateResponsiblePartiesFailure = createAction('[StepAssignees] update responsible parties failure');

export const resetAssigneesUpdateStatus = createAction('[StepAssignees] reset Assignees Update Status');
export const resetAssigneesUpdateModel = createAction('[StepAssignees] reset Assignees Update model');

export const setEditedCell = createAction('[StepAssignees] set Edited Cell', props<{ uuid: string }>());
export const resetEditedCell = createAction('[StepAssignees] reset Edited Cell');

export const setUserRadioList = createAction(
  '[StepAssignees] set User Radio List',
  props<{ allUsers: IRadioButtonOption<number>[] }>()
);
export const resetAllUserList = createAction('[StepAssignees] reset All User List');

export const updatePropertyUser = createAction(
  '[StepAssignees] update Property User',
  props<{ propertyUsers: PropertyAssignees[] }>()
);
export const resetPropertyUser = createAction('[StepAssignees] reset Property User');
